<template>
  <div class="pids-wrapper">
    <div
      class="pid"
      v-for="n in numberOfPids"
      :key="n"
      ref="pid"
      :class="{ '-active': !!pids[n] }"
    />
  </div>
</template>

<script>
export default {
  name: 'wtVolumeMeter',
  props: {
    volume: { type: Number, required: true },
    numberOfPids: { type: Number, required: false, default: 10 },
  },

  data() {
    return {
      pids: {},
    };
  },

  watch: {
    volume() {
      const all_pids = this.$refs.pid;
      const amout_of_pids = Math.round(this.volume / 10);
      const elem_range = all_pids.slice(0, amout_of_pids);
      for (let i = 1; i <= all_pids.length; i++) {
        this.$set(this.pids, i, false);
      }
      for (let i = 1; i <= elem_range.length; i++) {
        this.$set(this.pids, i, true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pids-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.pid {
  width: 22px;
  height: 6px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  transition: background-color 0.05s ease-out;

  &:not(:last-of-type) {
    margin-right: 2px;
  }
  &.-active {
    background-color: #20bc9c;
  }
}
</style>
